"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingPortalHeadersEnum = void 0;
var ShoppingPortalHeadersEnum;
(function (ShoppingPortalHeadersEnum) {
    ShoppingPortalHeadersEnum["AuthToken"] = "x-amz-portal-auth-token";
    ShoppingPortalHeadersEnum["AuthSessionId"] = "x-amz-auth-session-id";
    ShoppingPortalHeadersEnum["Cookie"] = "cookie";
    ShoppingPortalHeadersEnum["CustomerId"] = "x-amz-portal-customer-id";
    ShoppingPortalHeadersEnum["DeviceAttributes"] = "x-amz-portal-device-attr";
    ShoppingPortalHeadersEnum["InternalIpClass"] = "x-amazon-internal-ip-class";
    ShoppingPortalHeadersEnum["Locale"] = "x-amz-portal-language";
    ShoppingPortalHeadersEnum["MarketplaceId"] = "x-amz-portal-marketplace-id";
    ShoppingPortalHeadersEnum["OriginLocale"] = "origin-locale";
    ShoppingPortalHeadersEnum["OriginMarketplaceId"] = "origin-marketplace-id";
    ShoppingPortalHeadersEnum["PageNavNode"] = "x-amz-page-nav-node";
    ShoppingPortalHeadersEnum["PageNavStore"] = "x-amz-page-nav-store";
    ShoppingPortalHeadersEnum["PageNavTemplate"] = "x-amz-page-nav-template";
    ShoppingPortalHeadersEnum["PageType"] = "x-amz-page-type";
    ShoppingPortalHeadersEnum["PageTypeId"] = "x-amz-page-type-id";
    ShoppingPortalHeadersEnum["PageSubType"] = "x-amz-page-subtype";
    ShoppingPortalHeadersEnum["RequestId"] = "x-amz-rid";
    ShoppingPortalHeadersEnum["SessionId"] = "x-amz-portal-session-id";
    ShoppingPortalHeadersEnum["SessionIdAuthToken"] = "x-amz-portal-session-auth-token";
    ShoppingPortalHeadersEnum["TransitiveAuthToken"] = "x-amzn-transitive-authentication-token";
    ShoppingPortalHeadersEnum["SlateToken"] = "x-amzn-slate-token";
    ShoppingPortalHeadersEnum["UBID"] = "x-amz-portal-ubid";
    ShoppingPortalHeadersEnum["WeblabOverride"] = "x-amz-portal-weblabs";
    ShoppingPortalHeadersEnum["I18nPreferences"] = "x-amz-portal-i18n-preferences";
    ShoppingPortalHeadersEnum["PageFooterStyle"] = "x-amz-page-footer-style";
    ShoppingPortalHeadersEnum["TrafficPolicies"] = "x-amazon-wtm-tag-traffic-policies";
})(ShoppingPortalHeadersEnum = exports.ShoppingPortalHeadersEnum || (exports.ShoppingPortalHeadersEnum = {}));
